import { render, staticRenderFns } from "./punctuationDetailForRange.vue?vue&type=template&id=4e1263d0"
import script from "./punctuationDetailForRange.vue?vue&type=script&lang=js"
export * from "./punctuationDetailForRange.vue?vue&type=script&lang=js"
import style0 from "./punctuationDetailForRange.vue?vue&type=style&index=0&id=4e1263d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports